import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import clsx from "clsx";
import { parseISO, isValid, formatISO, format } from "date-fns";
import { AppointmentPickerDataTestIds } from "../../constants/dataTestIds.js";
import { Slot } from "./AvailableSlot.styles.js";
import "@mui/material";
import "@mui/material/styles";
const AvailableSlot = ({ dateString, start, onSlotSelected, keepTimezone, priority }) => {
  const date = useMemo(
    // eslint-disable-next-line no-nested-ternary
    () => dateString ? keepTimezone ? new Date(dateString) : new Date(dateString.split(".")[0]) : /* @__PURE__ */ new Date(),
    [dateString, keepTimezone]
  );
  const isSlotSelected = useMemo(() => {
    const selectedDate = parseISO(start);
    return isValid(selectedDate) ? formatISO(date) === formatISO(selectedDate) : false;
  }, [date, start]);
  const handleSlotSelection = (slotValue2) => () => onSlotSelected == null ? void 0 : onSlotSelected(slotValue2);
  const slotValue = formatISO(date);
  return /* @__PURE__ */ jsx(
    Slot,
    {
      component: "button",
      "data-testid": AppointmentPickerDataTestIds.AvailableSlot,
      "data-slot": true,
      "data-value": slotValue,
      underline: "none",
      onClick: handleSlotSelection(slotValue),
      className: clsx(isSlotSelected && "selected", `priority-${priority == null ? void 0 : priority.toLocaleLowerCase()}`),
      children: format(date, "HH:mm")
    }
  );
};
export {
  AvailableSlot as default
};
